import React, { useState, useEffect } from "react";
import * as Style from "./styledComponents/PersonalInstruction";
import Safe from "../assets/images/DeathModuleNew/Bitcoin Buy-1.png";
import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import copyLink from "../assets/images/DeathModuleNew/create-link-svgrepo-com.svg";
import menuIcon from "../assets/images/DeathModuleNew/Menu.png";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import List from "./styledComponents/Table/List";
import fileIcon from "../assets/images/DeathModuleNew/Icons.png";
import TitleImg from "../assets/images/DeathModuleNew/Rectangle 34624117.png";
import { Modal, Select } from "antd";
import Table from "./styledComponents/Table/Table";
import Loader from "../components/styled-components/loader/loader";
import AddModal from "./styledComponents/Modal/AddModal";
import UpdateModal from "./styledComponents/Modal/UpdateModal";
import DEATH_API from "../apis/death.api";
import MODULE_API from "../apis/module.api";
import ViewModal from "./styledComponents/Modal/ViewModal";
import swal from "sweetalert";
import axios from "axios";
import { ToolTipCreator } from "../helpers/ToolTipCreator";
const { Option } = Select;

export const DocumnetList = (props) => {
  const documnetcols = [
    {
      title: "Document Name",
      dataIndex: "name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Document Type",
      dataIndex: "type",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Storage Location of Document",
      dataIndex: "heldWhere",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "File",
      dataIndex: ["fileName", "fileUrl"],
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.fileUrl ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a
              style={{ color: "#7d8fb3" }}
              href={record.fileUrl}
              target="blank"
            >
              {" "}
              {record.fileName}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },

    {
      title: "Action",
      render: (record, index) => {
        // console.log("index...>>>",record.idx);
        return (
          <div>
            <div
              onClick={() => {
                setDropdown(!dropdown);
                getSelectedDocumnetRow(record.id);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          deleteSelectedDocumnetRow(record.id);
                          setDropdown(false);
                        }}
                      >
                        Delete
                      </li>
                    )}
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowUpdateModal(true);
                          setDropdown(false);
                        }}
                      >
                        Update
                      </li>
                    )}

                    <li
                      className="liHover"
                      onClick={() => {
                        setShowViewModal(true);
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          // setShowUpdateModal(true);
                          setShareModal(true);
                          setDropdown(false);
                        }}
                      >
                        Share Document
                      </li>
                    )}
                  </ul>
                </div>
              </>
            )}
          </div>
        );
      },
    },
  ];
  const policycols = [
    {
      title: "Policy's Nickname",
      dataIndex: "policyName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Carrier",
      dataIndex: "carrier",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Contact Name",
      dataIndex: "contactName",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Insurance Type",
      dataIndex: "contactType",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Contact Phone",
      dataIndex: "phoneNumber",
      render: (record) => (record ? formatPhoneNumber(record) : "N/A"),
    },
    {
      title: "File",
      dataIndex: ["fileName", "fileUrl"],
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.fileUrl ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a
              style={{ color: "#7d8fb3" }}
              href={record.fileUrl}
              target="blank"
            >
              {" "}
              {record.fileName}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Action",
      render: (record, index) => {
        // console.log("index...>>>",record.idx);
        return (
          <div>
            <div
              onClick={() => {
                setDropdown(!dropdown);
                setShowDocumentModal(false);
                getSelectedPolicyRow(record.id);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          deleteSelectedPolicyRow(record.id);
                          setDropdown(false);
                        }}
                      >
                        Delete
                      </li>
                    )}
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowUpdatePolicyModal(true);
                          setDropdown(false);
                        }}
                      >
                        Update
                      </li>
                    )}
                    <li
                      className="liHover"
                      onClick={() => {
                        setShowViewPolicy(true);
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          // setShowUpdateModal(true);
                          setShareModal(true);
                          setDropdown(false);
                        }}
                      >
                        Share Document
                      </li>
                    )}
                  </ul>
                </div>
              </>
            )}
          </div>
        );
      },
    },
  ];

  const documentFields = [
    {
      title: "Document Name",
      type: "input",
      index: "DocumentName",
    },
    {
      title: "Document Type",
      type: "select",
      options: [
        "Adoption Papers",
        "Birth Certificate",
        "Divorce Papers",
        "Driver's License",
        "Financial Accounts",
        "Financial Obligations",
        "Green Card",
        "ID",
        "Marriage License",
        "Medical",
        "Military",
        "Mortgage/Real Estate Deeds of Trust",
        "Naturalization Documents",
        "Passport",
        "Power of Attorney",
        "Social Security Card",
        "Sources of Income/Assets",
        "Trust",
        "Tax Statements",
        "Vehicle Registration/Ownership Papers",
        "Will",
        "Others",
      ],
      index: "DocumentType",
    },

    {
      title: "Storage Location Of Document",
      type: "input",
      index: "StorageLocationOfDocument",
    },
    {
      title: "File",
      type: "file",
      index: "file",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "Notes",
    },
  ];

  const UpdateDocumentFields = [
    {
      title: "Document Name",
      type: "input",
      index: "name",
    },
    {
      title: "Document Type",
      type: "select",
      options: [
        "Adoption Papers",
        "Birth Certificate",
        "Divorce Papers",
        "Driver's License",
        "Financial Accounts",
        "Financial Obligations",
        "Green Card",
        "ID",
        "Marriage License",
        "Medical",
        "Military",
        "Mortgage/Real Estate Deeds of Trust",
        "Naturalization Documents",
        "Passport",
        "Power of Attorney",
        "Social Security Card",
        "Sources of Income/Assets",
        "Tax Statements",
        "Trust",
        "Vehicle Registration/Ownership Papers",
        "Will",
        "Others",
      ],
      index: "type",
    },
    {
      title: "Storage Location Of Document",
      type: "input",
      index: "heldWhere",
    },
    {
      title: "File",
      type: "file",
      index: "fileUrl",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "note",
    },
  ];

  const policiesFields = [
    {
      title: "Policy's Nickname",
      type: "input",
      index: "PolicysNickname",
    },
    {
      title: "Policy Number",
      type: "input",
      index: "PolicyNumber",
    },
    {
      title: "Carrier",
      type: "input",
      index: "Carrier",
    },

    {
      title: "Insurance Type",
      type: "select",
      options: [
        "Auto Insurance",
        "Life Insurance",
        "Property Insurance",
        "Rental Insurance",
        "Others",
      ],
      index: "InsuranceType",
    },
    {
      title: "Contact Name",
      type: "input",
      index: "ContactName",
    },
    {
      title: "Contact Phone",
      type: "phoneNumber",
      index: "ContactPhone",
    },
    {
      title: "File",
      type: "file",
      index: "file",
    },
  ];

  const UpdatePoliciesFields = [
    {
      title: "Policy's Nickname",
      type: "input",
      index: "policyName",
    },
    {
      title: "Policy Number",
      type: "input",
      index: "policyNumber",
    },
    {
      title: "Carrier",
      type: "input",
      index: "carrier",
    },

    {
      title: "Insurance Type",
      type: "select",
      options: [
        "Auto Insurance",
        "Life Insurance",
        "Property Insurance",
        "Rental Insurance",
        "Others",
      ],
      index: "contactType",
    },
    {
      title: "Contact Name",
      type: "input",
      index: "contactName",
    },
    {
      title: "Contact Phone",
      type: "phoneNumber",
      index: "phoneNumber",
    },
    {
      title: "File",
      type: "file",
      index: "fileUrl",
    },
  ];
  const [tooltipModal, setTooltipModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [shareModal, setShareModal] = useState(false);

  const [showDocumnetModal, setShowDocumentModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showUpdatePolicyModal, setShowUpdatePolicyModal] = useState(false);

  const [addData, setaddData] = useState({});
  const [updateObject, setUpdateObject] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const [documents, setDocuments] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [deathCertificateUrl, setDeathCertificateUrl] = useState("");
  const [message, setMessage] = useState("");
  const [timer, setTimer] = useState("");
  const [copied, setCopied] = useState(null);

  const [showViewModal, setShowViewModal] = useState(false);

  const handelCloseShareModal = () => {
    setShareModal(false);
    setCopied(null);
  };
  const handelCloseViewModal = () => {
    setShowViewModal(false);
  };
  const [showViewPolicy, setShowViewPolicy] = useState(false);
  const handelCloseViewPolicyModal = () => {
    setShowViewPolicy(false);
  };

  const handleCloseDocumentModal = () => {
    setShowDocumentModal(false);
  };
  useEffect(() => {
    console.log("calling api");

    if (props.role == "protrustee") {
      isSecondPasswordGranted();
    } else {
      if (!localStorage.getItem("otp")) {
        localStorage.setItem("otp", "");
      }
      if (localStorage.getItem("otp") === "") {
        showModal();
      } else {
        getDocuments();
        getPolicies();
        getDeathCertificate();
      }
    }
  }, []);
  const showModal = async () => {
    setIsModalOpen(true);

    // this.setState({
    //   isModalOpen: true,
    // });
    // console.log("userData", this.state.userData);
    try {
      const ID = localStorage.getItem("accessId");

      let data = await DEATH_API.configOtp(ID);
      swal(data.message);
      // console.log("data.message",data.message)
    } catch (error) {
      console.log("e ", error);
    }
  };
  const getDocuments = async () => {
    try {
      // this.props.handleLoader();
      setLoading(true);
      setDocuments([]);
      console.log("this.state.userData", userData);
      if (localStorage.getItem("otp")) {
        const ID = localStorage.getItem("accessId");
        const docs = await DEATH_API.fetchDocuments(
          localStorage.getItem("otp"),
          ID
        );
        if (docs.message === "This is an expired OTP") {
          showModal();
        }
        // console.log("docs...document", docs.data);
        else {
          if (docs && docs.data) {
            setDocuments(docs.data);
          }
        }
      }
      setLoading(false);
      // this.props.handleLoader();
    } catch (error) {
      setLoading(false);
      // this.props.handleLoader();
      console.log(error);
    }
  };
  const getPolicies = async () => {
    try {
      // this.props.handleLoader();
      setLoading(true);
      console.log("this.state.userData", userData);
      setPolicies([]);
      if (localStorage.getItem("otp")) {
        const ID = localStorage.getItem("accessId");
        const policy = await DEATH_API.fetchPolicy(
          localStorage.getItem("otp"),
          ID
        );
        if (policy.message === "This is an expired OTP") {
          showModal();
        } else {
          if (policy && policy.data) {
            setPolicies(policy.data);
          }
        }
      }
      setLoading(false);
      // this.props.handleLoader();
    } catch (error) {
      setLoading(false);
      // this.props.handleLoader();
      console.log(error);
    }
  };
  const getDeathCertificate = async () => {
    try {
      // this.props.handleLoader();
      setLoading(true);
      console.log("this.state.userData", userData);
      if (localStorage.getItem("otp")) {
        const ID = localStorage.getItem("accessId");
        const DeathCerificate = await DEATH_API.getDeathCertificate(ID);
        console.log("DeathCerificate", DeathCerificate);
        if (DeathCerificate.status == 200) {
          setDeathCertificateUrl(DeathCerificate.data.deathCertificateUrl);
        }
      }
      setLoading(false);
      // this.props.handleLoader();
    } catch (error) {
      setLoading(false);
      // this.props.handleLoader();
      console.log(error);
    }
  };

  function formatPhoneNumber(phoneWithCountryCode) {
    // Remove any non-numeric characters from the phone number
    const numericPhoneNumber = phoneWithCountryCode.replace(/\D/g, "");
    if (
      numericPhoneNumber.startsWith("1") &&
      numericPhoneNumber.length === 11
    ) {
      // Format as a USA number (e.g., +1 408-123-4567)
      return `+1 ${numericPhoneNumber.slice(1, 4)}-${numericPhoneNumber.slice(
        4,
        7
      )}-${numericPhoneNumber.slice(7)}`;
    } else if (
      numericPhoneNumber.startsWith("44") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a UK number (e.g., +44 20 1234 5678)
      return `+44 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(
        4,
        8
      )} ${numericPhoneNumber.slice(8)}`;
    } else if (
      numericPhoneNumber.startsWith("49") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a Germany number (e.g., +49 30 12345678)
      return `+49 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(
        4,
        12
      )}`;
    } else if (
      numericPhoneNumber.startsWith("92") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a Pakistan number (e.g., +92 300 1234567)
      return `+92 ${numericPhoneNumber.slice(2, 5)} ${numericPhoneNumber.slice(
        5,
        12
      )}`;
    } else {
      return phoneWithCountryCode;
    }
  }

  const handleOk = async () => {
    console.log("login......", userData);
    let message = {};
    let policy = {};
    if (userData !== undefined) {
      // this.props.postSavedOtp(this.state.userData.otp)
      // localStorage.setItem("otp", userData.otp);
      // this.props.handleLoader()
      setLoading(true);

      try {
        setLoading(true);
        // this.props.handleLoader();
        const ID = localStorage.getItem("accessId");

        policy = await DEATH_API.fetchPolicy(userData && userData.otp, ID);
        setMessage(policy);
        message = policy;
        // this.setState({ message: policy })
        if (policy && policy.status === 200) {
          localStorage.setItem("otp", userData.otp);
        }
        if (policy && policy.status === 200 && policy.data) {
          setPolicies(policy.data);
        }
        const docs = await DEATH_API.fetchDocuments(
          userData && userData.otp,
          ID
        );
        // console.log("docs...document", docs.data);
        if (docs && docs.status === 200 && docs.data) {
          setDocuments(docs.data);
        }
        console.log("policy response", policy);
        // if(policy.message==="clients.otp.misMatch"){

        // }
        setLoading(false);
        // this.props.handleLoader();
        if (userData.otp) {
          setIsModalOpen(false);
        } else {
          swal("Oops!", "Invalid OTP", "error");
        }
      } catch (error) {
        setLoading(false);
        // this.props.handleLoader();
        console.log(error);
      }
    }
    console.log("message>>", message);
    if (
      policy &&
      policy.status === 400 &&
      policy.message === "Please enter a valid OTP"
    ) {
      swal("Oops!", "Please enter a valid OTP", "error");
      setIsModalOpen(true);
    }
  };
  const isSecondPasswordGranted = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.getSecondPasswordStatus(ID);
      setLoading(false);

      console.log("data.message", data.date.secondPasswordGranted);
      // setOTP_Status(data.date.secondPasswordGranted);
      if (data.date.secondPasswordGranted === 1) {
        if (!localStorage.getItem("otp")) {
          localStorage.setItem("otp", "");
        }
        if (localStorage.getItem("otp") === "") {
          showModal();
        } else {
          console.log("this.state.userData", userData);
          getDeathCertificate();
          getDocuments();
          getPolicies();
        }
      }

      if (data.date.secondPasswordGranted === 0) {
        setLoading(true);
        swal(
          "Restricted!",
          "You have not been granted access to this information.",
          "warning"
        );
        setLoading(false);
      }
    } catch (error) {
      console.log("e ", error);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    // this.props.postSavedOtp("")
    localStorage.setItem("otp", "");
  };

  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };

  const [showTextModal, setTextShowModal] = useState(false);
  const handelCloseTextModal = () => {
    setTextShowModal(false);
  };

  const handlechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handlePhoneChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };

  const handleRichTextChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateRichTextChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdatePhoneChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleDocumentChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDatePickerChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleRadioChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdatechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDocumentChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDatePickerChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateRadioChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleSelectChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdateSelectChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const SubmitUpdate = () => {
    console.log("updated object submit", updateObject);
    updateDocumentRow();
    handelCloseUpdateModal();
  };
  const SubmitPolicyUpdate = () => {
    console.log("updated object po submit", updateObject);
    updatePolicyRow();
    handelCloseUpdatePolicyModal();
  };
  const submitData = () => {
    console.log("submit data", addData);
    createDocumentRow();
    handleCloseDocumentModal();
  };
  const submitPolicyData = () => {
    console.log("submit data", addData);
    createPolicyRow();
    handelCloseTextModal();
  };
  // const handelCloseModal = () => {
  //   setShowModal(false);
  // };
  const handelCloseUpdateModal = () => {
    setShowUpdateModal(false);
  };
  const handelCloseUpdatePolicyModal = () => {
    setShowUpdatePolicyModal(false);
  };
  // const handelCloseUpdateTextModal = () => {
  //   setShowUpdateTextModal(false);
  // };
  const createPolicyRow = async (currentFormData) => {
    // check if already formData contains some data then initialize it with empty

    var arr = [addData];
    try {
      setLoading(true);
      let policies = arr;
      if (Array.isArray(policies) && policies.length > 0) {
        const allPromises = policies.map(async (item) => {
          if (item.File) {
            const formData = new FormData();
            formData.append("file", item.File);
            console.log("item.file", item.File);
            const name = item.File.name;
            const lastDot = name.lastIndexOf(".");
            const fileName = name.substring(0, lastDot);
            const ext = name.substring(lastDot + 1);
            const resdata = await MODULE_API.uploadFile({
              fileExt: ext,
              contentType: item.File.type,
            });
            const resupload = await axios.put(resdata.uploadUrl, item.File, {
              headers: { "Content-type": item.File.type },
            });
            const res = resdata.uploadUrl.split("?")[0];
            console.log(res);
            delete item.File;
            return { ...item, fileUrl: res, Upload: name };
          }
          return item;
        });
        let res = await Promise.all(allPromises);
        await DEATH_API.addPolicies({
          policiesForm: res.map((item) => {
            return {
              policyName: item["Policy's Nickname"],
              policyNumber: item["Policy Number"],
              carrier: item.Carrier,
              contactName: item["Contact Name"],
              contactType: item.InsuranceType,
              phoneNumber: item["Contact Phone"],
              fileUrl: item.fileUrl,
              fileName: item.Upload,
            };
          }),
        });
      }
      setLoading(false);
      getPolicies();
      return true;
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };
  const createDocumentRow = async () => {
    // check if already formData contains some data then initialize it with empty

    var arr = [addData];
    try {
      let data = arr;
      setLoading(true);
      if (Array.isArray(data) && data.length > 0) {
        const allPromises = data.map(async (item) => {
          if (item.File) {
            const formData = new FormData();
            formData.append("file", item.File);
            console.log("item.file", item.File);
            const name = item.File.name;
            const lastDot = name.lastIndexOf(".");
            const fileName = name.substring(0, lastDot);
            const ext = name.substring(lastDot + 1);
            const resdata = await MODULE_API.uploadFile({
              fileExt: ext,
              contentType: item.File.type,
            });
            const resupload = await axios.put(resdata.uploadUrl, item.File, {
              headers: { "Content-type": item.File.type },
            });
            const res = resdata.uploadUrl.split("?")[0];
            console.log(res);
            delete item.File;
            return { ...item, fileUrl: res, Upload: name };
          }
          return item;
        });
        let res = await Promise.all(allPromises);
        console.log("response of document upload", res);
        await DEATH_API.addDocuments({
          documentsForm: res.map((item) => {
            return {
              name: item["Document Name"],
              type: item.DocumentType,
              heldWhere: item["Storage Location Of Document"],
              note: item.Notes,
              fileUrl: item.fileUrl,
              fileName: item.Upload,
            };
          }),
        });
      }
      setLoading(false);
      getDocuments();
      return true;
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };
  const getSelectedDocumnetRow = (idx) => {
    console.log("idx", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = documents.filter((row, index) => {
      return row.id == idx;
    });

    // get first and only element from list and store it in update object
    console.log("selectedRow", selectedRow[0]);
    setUpdateObject(selectedRow[0]);
  };
  const getSelectedPolicyRow = (idx) => {
    console.log("idx", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = policies.filter((row, index) => {
      return row.id == idx;
    });

    // get first and only element from list and store it in update object
    console.log("selectedRow", selectedRow[0]);
    setUpdateObject(selectedRow[0]);
  };

  const deleteSelectedDocumnetRow = async (idx) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      confirmButtonColor: "#2a3da3",
      cancelButtonColor: "white",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deleteDocument(idx);
          setLoading(false);

          await getDocuments();
        } catch (error) {
          setLoading(false);
          console.log(error);
        }
        setTimeout(async () => {
          setLoading(false);
          swal("Deleted!", "Your file has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });
  };
  const deleteSelectedPolicyRow = async (idx) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);

          await DEATH_API.deletePolicy(idx);

          setLoading(false);
          await getPolicies();
        } catch (error) {
          setLoading(false);
          console.log(error);
        }
        setTimeout(async () => {
          setLoading(false);
          swal("Deleted!", "Your file has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });
  };
  //  function to update a specific document row
  const updateDocumentRow = async () => {
    try {
      setLoading(true);
      let uploaded = {};
      if (updateObject.File) {
        const formData = new FormData();
        formData.append("file", updateObject.File);

        const name = updateObject.File.name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: updateObject.File.type,
        });
        const resupload = await axios.put(
          resdata.uploadUrl,
          updateObject.File,
          { headers: { "Content-type": updateObject.File.type } }
        );
        const res = resdata.uploadUrl.split("?")[0];
        console.log("resss video url", res);
        uploaded.file_url = res;
        uploaded.fileName = name;
      } else {
        uploaded.fileUrl = "null";
      }

      // console.log("updated file Url", uploaded.file_url);
      let obj = {
        ...updateObject,
        name: updateObject["Document Name"],
        type: updateObject.type,
        heldWhere: updateObject["Storage Location Of Document"],
        note: updateObject.note,
        fileUrl: updateObject.file && uploaded.file_url,
        fileName: updateObject.file && uploaded.fileName,
      };
      delete obj.file;
      await DEATH_API.updateDocument(obj.id, obj);
      setLoading(false);
      getDocuments();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  //  function to update a specific Policy row
  const updatePolicyRow = async () => {
    try {
      setLoading(true);
      let uploaded = {};

      if (updateObject.File) {
        const formData = new FormData();
        formData.append("file", updateObject.File);

        const name = updateObject.File.name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: updateObject.File.type,
        });
        const resupload = await axios.put(
          resdata.uploadUrl,
          updateObject.File,
          { headers: { "Content-type": updateObject.File.type } }
        );
        const res = resdata.uploadUrl.split("?")[0];
        console.log("resss video url", res);
        // const uploaded = await MODULE_API.uploadImage(formData);
        uploaded.file_url = res;
        uploaded.fileName = name;
      } else {
        uploaded.fileUrl = "null";
      }

      console.log(updateObject.ContactName);
      let obj = {
        ...updateObject,
        policyName: updateObject["Policy's Nickname"],
        policyNumber: updateObject["Policy Number"],
        carrier: updateObject.carrier,
        contactName: updateObject["Contact Name"],
        contactType: updateObject.contactType,
        phoneNumber: updateObject.phoneNumber,
        fileUrl: uploaded.file_url,
        fileName: uploaded.fileName,
      };
      delete obj.file;

      await DEATH_API.updatePolicy(obj.id, obj);

      setLoading(false);
      getPolicies();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleShareDocument = async () => {
    const data = updateObject;
    console.log("updateObject", updateObject);
    if (updateObject.fileUrl !== null) {
      try {
        setLoading(true);
        let res = await DEATH_API.createSecureLink({
          link: updateObject.fileUrl,
          fileName: updateObject.fileName,
          shareWith: "TESTER",
          time: +timer,
        });
        setLoading(false);
        setCopied(res);
        console.log("res share documnet", res);
        getDocuments();
        return true;
      } catch (error) {
        console.log(error);
        throw new Error(error);
      }
    } else {
      swal("Error", "You Have No File To Share", "error");
    }
  };
  return (
    <div
      // style={{opacity:"0.5"}}
      style={{
        opacity:
          localStorage.getItem("otp") != "" && localStorage.getItem("otp") != ""
            ? "1"
            : "0.5",
      }}
    >
      {" "}
      {shareModal && (
        <Modal visible={shareModal} footer={null} closable={false} centered>
          <div style={{ marginTop: "20px" }}>
            <h4 style={{ color: "#4d5e80", marginBottom: "10px" }}>
              {" "}
              {copied && copied.preSignedUrl
                ? "Secure Link Created"
                : "Share Document Name Using Secure Link"}
            </h4>
            <div className="">
              <div>
                {copied && copied.preSignedUrl ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Style.Input
                      style={{ width: "70%" }}
                      value={copied && copied.preSignedUrl}
                      disabled={true}
                    ></Style.Input>
                    <Style.SaveButton
                      style={{ width: "20%", height: "40px" }}
                      onClick={() => {
                        navigator.clipboard.writeText(copied.preSignedUrl);
                        console.log("cooppues");
                        handelCloseShareModal();
                        swal("Success", "Copied", "success");
                      }}
                    >
                      <img
                        src={copyLink}
                        alt="copy"
                        height={25}
                        width={30}
                      ></img>
                    </Style.SaveButton>
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontFamily: "Poppins",
                      }}
                    >
                      {" "}
                      Secure Link becomes inactive (expires) after:
                    </div>
                    <Select
                      showSearch
                      placeholder="-Select-"
                      onChange={(value) => {
                        console.log("value", value);
                        setTimer(value);
                      }}
                    >
                      <Option value="3600">One Hour</Option>
                      <Option value="86400">One Day</Option>
                      <Option value="604800">One Week</Option>
                    </Select>
                  </>
                )}
                {copied && copied.preSignedUrl ? null : (
                  <Style.WrapperButtons>
                    <Style.CancelButton
                      onClick={() => {
                        handelCloseShareModal();
                      }}
                    >
                      Cancel
                    </Style.CancelButton>
                    <Style.SaveButton
                      onClick={() => {
                        handleShareDocument();
                      }}
                    >
                      Done
                    </Style.SaveButton>
                  </Style.WrapperButtons>
                )}
              </div>
            </div>
          </div>
          <Loader isLoading={loading} />
        </Modal>
      )}
      <Modal visible={isModalOpen} footer={null} closable={false} centered>
        <div style={{ marginTop: "20px" }}>
          {/* <div style={{padding:"50px",background:"black",overflow:"hidden"}}>hellow</div> */}
          <h3 style={{ color: "#4d5e80", marginBottom: "10px" }}>
            {" "}
            Important Documents
          </h3>
          <div className="">
            <h2 className="otp-heading" style={{ color: "#4d5e80" }}>
              This passcode provides another layer of security for your
              important documents. The passcode is only valid for this session.
            </h2>
            <div>
              <Style.Input
                onChange={(e) => {
                  e.persist();
                  setUserData((prevFormData) => ({
                    ...prevFormData,
                    [e.target.name]: e.target.value,
                  }));
                }}
                id="otp"
                type="text"
                // pattern="[0-9]{10}"
                pattern="[0-9.]+"
                // pattern="[0-9]+"
                // pattern="\d*"
                // maxlength="4"
                maxLength={6}
                placeholder="***OTP***"
                name="otp"
              />

              <Style.ResendButton
                onClick={async () => {
                  console.log();
                  setLoading(true);
                  const ID = localStorage.getItem("accessId");
                  let data = await DEATH_API.configOtp(ID);
                  swal(data.message);
                  setLoading(false);
                }}
              >
                Resend OTP
              </Style.ResendButton>

              <Style.WrapperButtons>
                <Style.CancelButton
                  id="stop"
                  onClick={() => {
                    handleCancel();
                  }}
                >
                  Cancel
                </Style.CancelButton>
                <Style.SaveButton onClick={handleOk}>Done</Style.SaveButton>
              </Style.WrapperButtons>
            </div>
          </div>
        </div>
        <Loader isLoading={loading} />
      </Modal>
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}
      >
        <Style.ModalTitle> Important Documents</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              This is another simple but critical feature to have in a program
              to maximize collaboration. There are variety of ways to store data
              and the idea was to simplify by allowing our servers store and
              back-up the data, thereby making it accessible with anyone
              authorized by Plan Creator as a Trusted Individual. Except for
              Advanced Health Care Directive, important documents are not
              accessible to anybody other than those with certain permissions
              and still must be authenticated using 2FA by text (SMS). Early
              access is not available for Trusted Individuals to ensure the
              secrecy of its contents and intent by Plan Creator. Only once the
              plan has been fully activated will this area and its contents be
              viewable by Trusted Individuals. Document examples include
              insurance policies, wills, trusts with amendments, birth
              certificate, deeds, divorce or civil settlement, misc. legal
              papers, scanned copies of personal letters, receipts, and much
              more. Death certificate URL might have been populated by Plan
              Creator to reflect the county in which they currently reside.
              There is no automation to this process and the program cannot
              order death certificates on behalf of anyone.
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                {tooltipModal && (
                  <video style={{ width: "25rem" }} controls>
                    <source
                      src={
                        "https://assets-planet.s3.amazonaws.com/media/ee51238e-81e5-4e62-a800-bd03a196a65b.mp4"
                      }
                      type="video/mp4"
                    />
                  </video>
                )}
              </div>
            </Style.ModalDetails>
          </div>
        </div>
      </Modal>
      {showDocumnetModal && (
        <AddModal
          show={showDocumnetModal}
          close={handleCloseDocumentModal}
          fields={documentFields}
          modalTitle="Add New Document"
          handlechange={handlechange}
          submitData={submitData}
          handleDocumentChange={handleDocumentChange}
          handleDatePickerChange={handleDatePickerChange}
          handleRadioChange={handleRadioChange}
          handlePhoneChange={handlePhoneChange}
          handleSelectChange={handleSelectChange}
          handleRichTextChange={handleRichTextChange}
        />
      )}
      {showUpdateModal && (
        <UpdateModal
          show={showUpdateModal}
          close={handelCloseUpdateModal}
          fields={UpdateDocumentFields}
          modalTitle="Update Document"
          handlechange={handleUpdatechange}
          submitData={SubmitUpdate}
          handleDocumentChange={handleUpdateDocumentChange}
          handleDatePickerChange={handleUpdateDatePickerChange}
          handleRadioChange={handleUpdateRadioChange}
          handleUpdateSelectChange={handleUpdateSelectChange}
          handleUpdatePhoneChange={handleUpdatePhoneChange}
          handleUpdateRichTextChange={handleUpdateRichTextChange}
          obj={updateObject}
        />
      )}
      {showTextModal && (
        <AddModal
          show={showTextModal}
          close={handelCloseTextModal}
          fields={policiesFields}
          modalTitle="Add New Policy"
          handlechange={handlechange}
          submitData={submitPolicyData}
          handleDocumentChange={handleDocumentChange}
          handleDatePickerChange={handleDatePickerChange}
          handleRadioChange={handleRadioChange}
          handlePhoneChange={handlePhoneChange}
          handleSelectChange={handleSelectChange}
          handleRichTextChange={handleRichTextChange}
        />
      )}
      {showUpdatePolicyModal && (
        <UpdateModal
          show={showUpdatePolicyModal}
          close={handelCloseUpdatePolicyModal}
          fields={UpdatePoliciesFields}
          modalTitle="Update Policy"
          handlechange={handleUpdatechange}
          submitData={SubmitPolicyUpdate}
          handleDocumentChange={handleUpdateDocumentChange}
          handleDatePickerChange={handleUpdateDatePickerChange}
          handleRadioChange={handleUpdateRadioChange}
          handleUpdateSelectChange={handleUpdateSelectChange}
          handleUpdatePhoneChange={handleUpdatePhoneChange}
          handleUpdateRichTextChange={handleUpdateRichTextChange}
          obj={updateObject}
        />
      )}
      {showViewModal && (
        <ViewModal
          show={showViewModal}
          close={handelCloseViewModal}
          fields={UpdateDocumentFields}
          modalTitle="View Document"
          obj={updateObject}
        />
      )}
      {showViewPolicy && (
        <ViewModal
          show={showViewPolicy}
          close={handelCloseViewPolicyModal}
          fields={UpdatePoliciesFields}
          modalTitle="View Policy"
          obj={updateObject}
        />
      )}
      <Style.MainHeading>
        {/* <Style.HeaderImg src={Safe} alt="Safe"></Style.HeaderImg> */}
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          Important Documents{" "}
          <ToolTipCreator name={"Death_Important_Documents"}/>
        </div>
        {/* <Style.HelpIcon
          src={helpIcon}
          alt="helpicon"
          onClick={() => {
            showTooltipModal();
          }}
        ></Style.HelpIcon> */}
      </Style.MainHeading>
      <div
        style={{
          marginTop: "1rem",
          background: "white",
          padding: "10px",
          display: "flex",
          borderRadius: "5px",
          width: "30rem",
          justifyContent: "space-around",
        }}
      >
        <input
          id="file-input"
          type="text"
          placeholder="Death Certificate Url"
          style={{ border: "none", outline: "none", width: "60.5%" }}
          defaultValue={deathCertificateUrl}
          disabled={props.role !== "protrustee" ? false : true}
        />
        <img src={fileIcon} alt="fileIcon"></img>
        {/* <label for="file-input"> */}
        <Style.SaveButton
          style={{ width: "5rem" }}
          disabled={props.role !== "protrustee" ? false : true}
          // isDisabled={props.role !== "protrustee" ? false : true}
          onClick={async () => {
            let URL = document.getElementById("file-input").value;
            console.log("URL", URL);
            setLoading(true);
            // this.props.handleLoader();
            const res = await DEATH_API.PostDeathCertificate({
              deathCertificateUrl: URL,
            });
            setLoading(false);

            // this.props.handleLoader();
            console.log("res", res);
            // swal("Success!", res.message, "success");
          }}
        >
          Save
        </Style.SaveButton>

        {/* </label> */}
      </div>
      <div
        style={{
          fontFamily: "Poppins",
          fontSize: "17px",
          textAlign: "center",
          color: "black",
          marginTop: "4px",
        }}
      >
        If newly added files are not showing, the One-Time Passcode may not have
        been entered correctly. Please log out, log back in and try again.
      </div>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Important Documents</Style.Title>
          {props.role !== "protrustee" && localStorage.getItem("otp") != "" && (
            <div>
              <Style.Button
                onClick={() => {
                  setDropdown(false);
                  setShowDocumentModal(true);
                }}
              >
                +
              </Style.Button>
            </div>
          )}
        </Style.HealthCardHeader>
        <List cols={documnetcols} rows={documents}></List>
      </Style.HealthCard>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Insurance Policies</Style.Title>
          {props.role !== "protrustee" && localStorage.getItem("otp") != "" && (
            <div>
              <Style.Button
                onClick={() => {
                  setDropdown(false);
                  setTextShowModal(true);
                }}
              >
                +
              </Style.Button>
            </div>
          )}
        </Style.HealthCardHeader>
        <List cols={policycols} rows={policies}></List>
      </Style.HealthCard>
      <Loader isLoading={loading} />
    </div>
  );
};
